import ModuleWrapper from '@/components/page/ModuleWrapper';

const OfferWall = () => import(/* webpackChunkName: "dashboard" */ '@/views/OfferWall/OfferWall');

const meta = (data = {}) => ({
    moduleName: 'offerWall',
    auth: true,
    ...data,
});

export default [{
    path: 'offer-wall',
    component: ModuleWrapper,
    meta: meta({
        title: 'Offer Wall',
    }),
    children: [
        {
            path: '',
            name: 'OfferWall',
            component: OfferWall,
            props: true,
            meta: meta({}),
        },
    ],
}];
